export default "__VITE_ASSET__BvpQ7t_L__"